import React, { useEffect, useState } from "react";
import {
  Modal,
  Form,
  Input,
  DatePicker,
  InputNumber,
  Row,
  Col,
  Select,
  message,
} from "antd";
import moment from "moment";
import Button from "src/components/MyButton/Button";
import WarehouseService from "src/services/WarehouseService";

const ModalCreate = ({ open, onCancel, onOk, record, onlyView }) => {
  const [form] = Form.useForm();
  const [countries, setCountries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [providers, setProviders] = useState([]);
  const [carries, setCarries] = useState([]);
  const [rejectMessage, setRejectMessage] = useState("");
  const [showRejectMessage, setShowRejectMessage] = useState(false);

  useEffect(() => {
    if (record) {
      form.setFieldsValue({
        ...record,
        import_date: moment(record.import_date),
      });
    } else {
      form.resetFields();
    }
  }, [record, form]);

  useEffect(() => {
    if (open) {
      fetchProvider();
      fetchCountries();
      fetchCarrier();
    }
  }, [open]);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      const payload = {
        ...values,
        import_date: values.import_date.format("YYYY-MM-DD"),
        unit_price: 10,
        data_unit_price: 10,
      };

      let response;
      if (record) {
        response = await WarehouseService.warehouseUpdate(record.id, payload);
      } else {
        response = await WarehouseService.createWarehouseIn(payload);
      }

      if (response.message) {
        message.success(record ? "Cập nhật thành công!" : "Đã gửi duyệt thành công!");
        onOk?.();
        form.resetFields();
      } else {
        message.error(record ? "Cập nhật thất bại!" : "Gửi duyệt thất bại!");
      }
    } catch (error) {
      console.error("Lỗi:", error);
      message.error("Có lỗi xảy ra, vui lòng thử lại!");
    } finally {
      setLoading(false);
    }
  };

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        handleSubmit(values);
      })
      .catch((error) => {
        console.error("Lỗi validate form:", error);
      });
  };

  const handleCancel = () => {
    onCancel?.();
    message.info("Đã huỷ!");
  };

  const handleReject = () => {
    if (!rejectMessage.trim()) {
      message.error("Vui lòng nhập lý do từ chối");
      return;
    }
    message.success(`Đã từ chối với lý do: ${rejectMessage}`);
    onCancel?.();
  };

  const handleApprove = () => {
    message.success("Đã duyệt thành công");
    onCancel?.();
  };

  const fetchCountries = async () => {
    try {
      const response = await WarehouseService.getAllCountries();
      setCountries(response?.success || []);
    } catch (error) {
      console.error("Lỗi khi lấy danh sách quốc gia", error);
      message.error("Không thể lấy danh sách quốc gia");
    }
  };

  const fetchProvider = async () => {
    try {
      const response = await WarehouseService.getListProvider();
      setProviders(response?.success?.data || []);
    } catch (error) {
      console.error("Lỗi khi lấy danh sách nhà cung cấp", error);
      message.error("Không thể lấy danh sách nhà cung cấp");
    }
  };

  const fetchCarrier = async () => {
    try {
      const response = await WarehouseService.getListCarrier();
      setCarries(response?.success || []);
    } catch (error) {
      console.error("Lỗi khi lấy danh sách nhà mạng", error);
      message.error("Không thể lấy danh sách nhà mạng");
    }
  };

  return (
    <Modal
      title={record ? "Chỉnh sửa phiếu nhập kh0" : "Tạo mới phiếu nhập kho"}
      open={open}
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      width={800}
      footer={
        onlyView ? (
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
            <Button danger onClick={() => setShowRejectMessage(true)}>
              Từ chối
            </Button>
            <Button type="primary" onClick={handleApprove}>
              Duyệt
            </Button>
          </div>
        ) : (
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
            <Button onClick={handleCancel}>Huỷ</Button>
            <Button btnType="primary1" onClick={handleOk} loading={loading}>
              {record ? "Cập nhật" : "Gửi duyệt đơn"}
            </Button>
          </div>
        )
      }
    >
      <Form form={form} layout="vertical">
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Nhà cung cấp"
              name="providers_id"
              
            >
              <Select placeholder="Chọn nhà cung cấp" allowClear rules={[{ required: true, message: "Vui lòng chọn nhà cung cấp" }]}>
                {providers.map((provider) => (
                  <Select.Option key={provider.id} value={provider.id}>
                    {provider.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Nhà mạng"
              name="carrier_id"
              rules={[{ required: true, message: "Vui lòng chọn nhà mạng" }]}
            >
              <Select placeholder="Chọn nhà mạng" allowClear disabled={onlyView}>
                {carries.map((carrier) => (
                  <Select.Option key={carrier.id} value={carrier.id}>
                    {carrier.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Chọn quốc gia"
              name="country_id"
              rules={[{ required: true, message: "Vui lòng chọn quốc gia" }]}
            >
              <Select placeholder="Chọn quốc gia" allowClear disabled={onlyView}>
                {countries.map((country) => (
                  <Select.Option key={country.id} value={country.id}>
                    {country.title}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Số lô nhập"
              name="batch_number"
              rules={[{ required: true, message: "Vui lòng nhập số lô nhập" }]}
            >
              <Input placeholder="Nhập số lô nhập" disabled={record || onlyView} />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            {!record && (
              <Form.Item
                label="Serial"
                name="serial_number"
                rules={[
                  { required: true, message: "Vui lòng nhập serial" },
                  {
                    pattern: /^\d{16,32}$/,
                    message: "Serial phải từ 16 đến 32 chữ số",
                  },
                ]}
              >
                <Input
                  maxLength={32}
                  placeholder="Nhập serial"
                  onKeyPress={(e) => {
                    if (!/[0-9]/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  disabled={onlyView}
                />
              </Form.Item>
            )}
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              label="Loại SIM"
              name="type_sim"
              initialValue="E-SIM"
              rules={[{ required: true, message: "Vui lòng nhập loại sim" }]}
            >
              <Select placeholder="Loại SIM" disabled>
                <Select.Option value="E-SIM">E-SIM</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Loại hình SIM"
              name="sim_type"
              rules={[{ required: true, message: "Vui lòng chọn loại hình sim" }]}
            >
              <Select placeholder="Chọn loại hình SIM" allowClear disabled={onlyView}>
                <Select.Option value="Sim tồn">SIM tồn</Select.Option>
                <Select.Option value="Sim lỗi">SIM lỗi</Select.Option>
                <Select.Option value="Đang hoạt động">Đang hoạt động</Select.Option>
                <Select.Option value="Đã thu hồi">Đã thu hồi</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Đơn giá SIM"
              name="unit_price"
              rules={[{ required: true, message: "Vui lòng nhập đơn giá SIM" }]}
            >
              <InputNumber
                min={0}
                style={{ width: "100%" }}
                placeholder="Nhập đơn giá"
                disabled={onlyView}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Ngày nhập"
              name="import_date"
              rules={[{ required: true, message: "Vui lòng chọn ngày nhập" }]}
              initialValue={moment()}
            >
              <DatePicker style={{ width: "100%" }} format="YYYY-MM-DD" disabled={onlyView} />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Loại chiết khấu"
              name="discount_type"
              rules={[{ required: true, message: "Vui lòng chọn loại chiết khấu" }]}
            >
              <Select placeholder="Chọn loại chiết khấu" allowClear disabled={onlyView}>
                <Select.Option value="%">Chiết khấu %</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label="Chiết khấu"
              name="discount_value"
              rules={[{ required: true, message: "Vui lòng nhập chiết khấu" }]}
            >
              <Input placeholder="Nhập chiết khấu" disabled={onlyView} />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      {showRejectMessage && (
        <div style={{ marginTop: 16 }}>
          <Input.TextArea
            placeholder="Nhập lý do từ chối"
            value={rejectMessage}
            onChange={(e) => setRejectMessage(e.target.value)}
            rows={3}
          />
          <Button
            type="primary"
            onClick={handleReject}
            style={{ marginTop: 8 }}
          >
            Xác nhận từ chối
          </Button>
        </div>
      )}
    </Modal>
  );
};

export default ModalCreate;
